import React, { useState } from 'react';
import { payAutionAmount, updateAuctionStatus } from '../../../../../redux/auction/action';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SendOTP from '../ProductforsaleDetails/SendOTP';
import { getDateFormate } from '../../../../Common/AllDateTimeReleventFormate';
import ConfirmModal from '../../../../Common/ConfirmModal';

export default function AuctionOrderStatusss({ data, winner }) {
    const laung = localStorage.getItem("laung");
    const [lan, setLan] = useState(laung ?? "en");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [otp, setOTP] = useState('');

    // 🔴 Confirmation modal states
    const [confirmModal, setConfirmModal] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pendingAction, setPendingAction] = useState(null);
    const [pendingActionParams, setPendingActionParams] = useState(null);

    // ---------------- CONFIRM HANDLER ----------------
    const openConfirm = (action, msg, params = null) => {
        setPendingAction(() => action);
        setPendingActionParams(params);
        setConfirmMsg(msg);
        setConfirmModal(true);
    };

    const handleConfirm = () => {
        if (pendingAction) {
            if (pendingActionParams) {
                pendingAction(pendingActionParams);
            } else {
                pendingAction();
            }
        }
        setPendingAction(null);
        setPendingActionParams(null);
        setConfirmModal(false);
    };

    // ---------------- ACTIONS ----------------
    const PayExpert = () => {
        // navigate(`/${lan}/auctioncontract/${data?.id}`, {
        //     state: { approvefrom: "buyer", type: "auction" },
        // });
        const state = {
        id: data?.id,
        bid_id: data?.winning_bid[0]?.id,
        type: 3,
        type_of_post: "auction",
        post_id: data?.id,
        post_price: data?.winning_bid[0]?.payable_amount || data?.price,
      };
      const data1 = {
        "bid_id": data?.id,
        "type": "4",
        image: "",
        url: `/${lan}/account/paymentmethodpage`,
        state: state,
      };

         navigate(data1?.url, {
            state: {
                orderdetails: {
                    ...data1?.state,
                },
            },
        });
    };

    const DeliveryStatus = () => {
        const data1 = {
            "type": "1",
            "status": "4",
            "bid_id": winner?.id,
            "id": data?.id,
        };
        dispatch(updateAuctionStatus(data1));
    };

    const ItemDelivered = () => {
        const data1 = {
            "type": "1",
            "status": "5",
            "bid_id": winner?.id,
            "id": data?.id,
        };
        dispatch(updateAuctionStatus(data1));
    };

    const Transactioncomplete = () => {
        const data1 = {
            "type": "1",
            "status": "6",
            "bid_id": winner?.id,
            "otp": otp,
            "id": data?.id,
        };
        dispatch(updateAuctionStatus(data1));
    };

    const getStatusByValue = (statusValue) => {
        return Array.isArray(winner?.status_history) && winner?.status_history?.find((item) => item.status == statusValue);
    };

    const status2 = getStatusByValue(2);
    const status3 = getStatusByValue(3);
    const status4 = getStatusByValue(4);
    const status5 = getStatusByValue(5);
    const status6 = getStatusByValue(6);
    const status7 = getStatusByValue(7);

    return (
        <div className='status-history'>
            {/* STEP 1 */}
            <div className="status-first">
                <div className={`number ${winner?.status == 2 ? 'processing' : winner?.status > 2 ? 'complete' : ''}`}>
                    <span>1</span>
                </div>
                <div className='status-right'>
                    <h6>Pay Bid Amount</h6>
                    <h2>SAR {winner?.payable_amount} {winner?.status <= 2 && <span className='status-btn pending'>Amount Pending</span>}</h2>
                    {winner?.status > 2 && <span className='status-btn paid'>Amount Paid</span>}
                    {winner?.status > 2 && <p className='status-p'>Paid on : {getDateFormate(status2?.created_on)}</p>}
                    {
                        (winner?.status == 2 && winner?.is_mine == 1) &&
                        <span
                            className='status-btn mark-delivered'
                            onClick={() => openConfirm(PayExpert, "Are you sure you want to pay the bid amount?")}
                        >
                            Pay Now
                        </span>
                    }
                </div>
            </div>

            {/* STEP 2 */}
            <div className="status-first">
                <div className={`number ${winner?.status == 3 ? 'processing' : winner?.status > 3 ? 'complete' : ''}`}>
                    <span>2</span>
                </div>
                <div className='status-right'>
                    <h6>Out for Delivery</h6>
                    {winner?.status > 3 && <span className='status-btn paid'>Out for Delivery</span>}
                    {winner?.status <= 3 && <span className='status-btn pending'>not Out for Delivery</span>}
                    {winner?.status > 3 && <p className='status-p'>On :{getDateFormate(status3?.created_on)}</p>}

                    {
                        (winner?.status == 3 && data?.is_mine == 1 && winner?.is_mine != 1) &&
                        <span
                            className='status-btn mark-delivered'
                            onClick={() => openConfirm(DeliveryStatus, 'Are you sure you want to mark it as "Out for delivery"?')}
                        >
                            Update status
                        </span>
                    }
                </div>
            </div>

            {/* STEP 3 */}
            <div className="status-first">
                <div className={`number ${winner?.status == 4 ? 'processing' : winner?.status > 4 ? 'complete' : ''}`}>
                    <span>3</span>
                </div>
                <div className='status-right'>
                    <h6>Item Delivered</h6>
                    {winner?.status > 4 && <span className='status-btn paid'>delivered</span>}
                    {winner?.status > 4 && <p className='status-p'>On :{getDateFormate(status4?.created_on)}</p>}
                    {winner?.status <= 4 && <span className='status-btn pending'>not delivered yet</span>}

                    {(winner?.status > 4 && data?.is_mine == 0 && winner?.status != 6) &&
                        <div className='deliveryotp-sec d-flex align-items-center '>
                            <div>
                                <h6>Delivery OTP</h6>
                                <p className='status-p'>Please provide the OTP to the seller once the item is delivered</p>
                            </div>
                            <span className='status-btn mark-delivered otp-number'>{winner?.delivery_otp}</span>
                        </div>
                    }

                    {
                        (winner?.status == 4 && winner?.is_mine == 1) &&
                        <span
                            className='status-btn mark-delivered'
                            onClick={() => openConfirm(ItemDelivered, 'Are you sure you want to mark it as "Item delivered"?')}
                        >
                            Mark Delivered
                        </span>
                    }
                </div>
            </div>

            {/* STEP 4 */}
            <div className="status-first">
                <div className={`number ${winner?.status == 5 ? 'processing' : winner?.status > 5 ? 'complete' : ''}`}>
                    <span>4</span>
                </div>
                <div className='status-right'>
                    <h6>Transaction Complete</h6>
                    {winner?.status > 5 && <span className='status-btn paid'>Transaction Complete</span>}
                    {winner?.status <= 5 && <span className='status-btn pending'>Transaction not complete yet</span>}
                    {winner?.status > 5 && <p className='status-p'>On :{getDateFormate(status5?.created_on)}</p>}

                    {(winner?.status == 5 && data?.is_mine == 1 && winner?.is_mine != 1) &&
                        <div className='deliveryotp-sec '>
                            <h6>Delivery OTP</h6>
                            <p className='status-p'>
                                Please enter the OTP to complete the transaction.
                            </p>
                            <SendOTP
                                setOTP={setOTP}
                                Transactioncomplete={() => openConfirm(Transactioncomplete, 'Are you sure you want to mark this transaction as "Completed"?')}
                            />
                        </div>
                    }
                </div>
            </div>

            {/* CONFIRM MODAL */}
            <ConfirmModal
                isOpen={confirmModal}
                toggle={() => setConfirmModal(false)}
                // title="Do you want to update the status?"
                title=""
                message={confirmMsg}
                onConfirm={handleConfirm}
            />
        </div>
    );
}